import { createFileRoute } from '@tanstack/react-router'
import { DashboardNewServer } from '@/pages/DashboardNewServer'

export const Route = createFileRoute('/$orgId/dashboard/servers/new')({
  component: DashboardNewServer,
  meta: () => [{ title: 'New Server' }],
})
